import { z } from 'zod';

export const newsletterSchema = z.object({
  email: z
    .string()
    .min(1, 'El email es requerido')
    .email('Ingresa un email válido')
    .max(255, 'El email no debe exceder 255 caracteres'),
});

export type NewsletterFormData = z.infer<typeof newsletterSchema>;
